// Firebase config pulled from environment variables

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyD5sbv9pgqA2epDUwuV-Jehe58u6Adj9W0",
  authDomain: "runas-archive.firebaseapp.com",
  projectId: "runas-archive",
  storageBucket: "runas-archive.appspot.com",
  messagingSenderId: "974186948350",
  appId: "1:974186948350:web:f7e992a762c46a5d2a27af",
  measurementId: "G-VRN855J7FR"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
// Firebase Auth
export const auth = getAuth(app);

// Firebase Storage
export const storage = getStorage(app);
